<template>
  <div class="container">
    <HeaderTabBar :defState="state" @myClick="changeState" />

    <div class="list">
      <van-list v-model="show.loading" :finished="show.finished" @load="onLoad">
        <template v-if="list.length">
          <ClassCard
            v-for="item in list"
            :key="item.id"
            :id="item.id"
            :title="item.title"
            :identityCode="item.identityCode"
            :begDate="item.begDate"
            :endDate="item.endDate"
            :stateText="item.stateText"
            @click.native="jumpPage(item.id)"
          />
        </template>
      </van-list>

      <div class="empty" v-show="!list.length">
        <img src="@/assets/my-clock-in-empty.png" alt="" class="empty-img">
        <p class="empty-text">暂无班级数据</p>
      </div>
    </div>

    <img src="@/assets/youjiang.png" alt="logo" class="logo" />
  </div>
</template>

<script>
import { getClassList } from '@/api/clockin';
import { List } from 'vant';
import HeaderTabBar from './components/HeaderTabBar.vue';
import ClassCard from './components/ClassCard.vue';

export default {
  components: {
    HeaderTabBar,
    ClassCard,
    [List.name]: List,
  },
  data() {
    return {
      state: -1, // 班级状态
      page: {
        limit: 10,
        offset: 0,
      },
      count: 0,
      list: [],
      show: {
        finished: false,
        loading: false,
      },
    };
  },
  methods: {
    changeState(val) {
      this.state = val;

      this.resetState();
    },
    onLoad() {
      const data = {
        process: this.state,
        limit: this.page.limit,
        offset: this.page.offset
      };

      getClassList(data).then((res) => {
        this.count = res.count;

        if (res.items.length) {
          const list = res.items.map(item => ({
            id: item.id,
            title: item.name,
            begDate: item.training_date.replace(/[-]/g, '.'),
            endDate: item.finish_date.replace(/[-]/g, '.'),
            identityCode: item.duty_type,
            stateText: item.training_desc,
          }));

          this.list.push(...list);
          this.show.loading = false;
          this.page.offset = this.list.length;
        } else {
          this.show.loading = false;
          this.show.finished = true;
        }

        if (this.list.length >= this.count) {
          this.show.finished = true;
        }
      });
    },
    jumpPage(id) {
      this.$router.push(`/admin-class-detail/${id}`);
    },
    resetState() {
      this.count = 0;
      this.page.offset = 0;
      this.list = [];
      this.show.finished = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #F6F7FA;
}

.logo {
  position: absolute;
  bottom: 12px;
  right: calc(50% - 32px);
  width: 64px;
}

.list {
  position relative
  padding: 16px;
}

.empty {
  position absolute
  top 160px
  left 0
  width 100%

  .empty-img {
    display block
    margin 0 auto
    width 255px
    border none
  }

  .empty-text {
    margin-top 13px
    text-align center
    font-size 14px
    color #999
    line-height 14px
    font-weight 400
  }
}
</style>
